import { RouterItemType } from "@/app/index";
import { lazy } from "react";

const LayoutPageMarketplace = lazy(() => import("./layout/index"));

export const routerPageMarketplace: RouterItemType = {
  path: "/store",
  authorize: false,
  element: <LayoutPageMarketplace />,
};
